import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'
import { useNavigate } from 'react-router-dom'

import { format, endOfMonth } from 'date-fns'

// css
import 'assets/style/common.scss'

// components
import {
  Label,
  Text,
  Heading,
  InfoList,
  Line,
  ListTitle,
  SearchBarOptions,
  DateRangePicker,
  SplitBar,
  IconButton,
  Breadcrumb,
  SelectOption,
} from 'components'

import { usePreAplctPsntLst } from 'api/head/headpreorder-fetch'
import { APP_INFO_CONST } from 'constants/app_info_const'

import { userInfoState, shopListState, siteListState } from 'store/atom/user-state-atom'
import { useRecoilValue } from 'recoil'

// 키값으로 그룹화
const rebase = (data, key) =>
  data.reduce((acc, cur) => {
    acc[cur[key]] = acc[cur[key]] || []
    acc[cur[key]].push(cur)
    return acc
  }, {})

// 매뉴 부분
function ListItem({ id, data, name, siteNm, siteId, goodsAplctNm }) {
  const { closeModal } = useModal()
  const navigate = useNavigate()
  return (
    <>
      <div className="title-border-box flex-between mt32">
        <Heading text={goodsAplctNm} className="f-16 c-3 f-bold" />
        <IconButton
          type="more-arrow"
          size="16"
          onClick={() => {
            closeModal()
            navigate(`/goods/preorder/${id}`)
          }}
        />
      </div>
      <section className="mt16 border-d border-radius-2 p12">
        <Breadcrumb level="2" data={[`[${siteId}]${siteNm}`, name]} />
        {data.map(({ goodsNo, gdBd, enterPsbtStartDt, enterPsbtTmntDt, odrCqty, rmrk, ordrUnitCd }, i) => (
          <>
            <InfoList
              className="mt12"
              level="2"
              dataAlign="right"
              col="1"
              data={[
                { id: 1, title: '상품명', data: `[${goodsNo}] ${gdBd}` },
                { id: 2, title: '주문수량', data: `${odrCqty * 1}${ordrUnitCd}` },
                {
                  id: 3,
                  title: '입고가능일',
                  data:
                    parseInt(odrCqty) === 0
                      ? '신청안함'
                      : `${enterPsbtStartDt?.replace(/-/g, '.') || ''} ~ ${enterPsbtTmntDt?.replace(/-/g, '.') || ''}`,
                },
                {
                  id: 4,
                  title: '비고',
                  data: rmrk,
                },
              ]}
            />
            {/* {rmrk && <Text className="f-12 mt8" text={rmrk} />} */}
            {/* <Line size="1" color="gray" className="mt8 mb8" /> */}
          </>
        ))}
      </section>
    </>
  )
}

function PreOrderList() {
  const userInfo = useRecoilValue(userInfoState)
  const siteList = useRecoilValue(siteListState)
  const [menuList, setMenuList] = useState([])

  const today = new Date()
  const startDt = new Date(today.getFullYear(), today.getMonth(), 1)
  const endDt = endOfMonth(today)

  const [isInit, setIsInit] = useState(true)
  const [queryOptions, setQueryOptions] = useState({
    size: APP_INFO_CONST.PAGE_SIZE,
    page: 1,
    siteId: userInfo.siteId,
    keyword: '',
    searchStartDt: format(startDt, 'yyyyMMdd'),
    searchEndDt: format(endDt, 'yyyyMMdd'),
  })

  const { isSuccess, data, remove } = usePreAplctPsntLst(queryOptions, isInit)

  useEffect(() => {
    if (isSuccess) {
      setIsInit(false)

      const ntcs = rebase(data.data, 'ntcAtclId')
      const menuList = []
      for (const id in ntcs) {
        const ntc = ntcs[id]
        menuList.push({
          id,
          name: ntc[0].regrNm,
          siteNm: ntc[0].siteNm,
          siteId: ntc[0].siteId,
          goodsAplctNm: ntc[0].goodsAplctNm,
          data: ntc,
        })
      }

      setMenuList(menuList) // 분류순으로 정렬
    }
  }, [data])

  // 검색버튼
  const goSearch = (text) => {
    console.log('검색어 :', text)
    remove()
    setIsInit(true)
    setQueryOptions({
      ...queryOptions,
      keyword: text,
    })
  }

  return (
    <main>
      <SearchBarOptions goSearch={goSearch}>
        <li>
          <Label text="사이트" />
          <SelectOption
            textKey="name"
            valueKey="siteId"
            list={siteList.map((site) => ({ ...site, name: `[${site.siteId}]${site.siteNm}` }))}
            onChange={(e) => {
              setQueryOptions({
                ...queryOptions,
                siteId: e.target.value,
                // siteId: value,
              })
            }}
          />
        </li>
        <li>
          <Label text="검색기간" />
          <DateRangePicker
            dateRange={{
              startDate: startDt,
              endDate: endDt,
            }}
            changeDate={(s, e) => {
              console.log('검색기간', s, e)
              setQueryOptions({
                ...queryOptions,
                searchStartDt: format(s, 'yyyyMMdd'),
                searchEndDt: format(e, 'yyyyMMdd'),
              })
            }}
          />
        </li>
      </SearchBarOptions>
      <SplitBar className="mt32" />

      <div className="wrapper">
        <article>
          <div className="flex-col mb10 pt24">
            <ListTitle title="검색결과" count={menuList.length} className="border-none mb8" />
            <Line size="2" color="black" />

            {/* 검색결과 */}
            {menuList.map((o, i) => (
              <ListItem key={i} {...o} />
            ))}
          </div>
        </article>
      </div>
    </main>
  )
}

export default PreOrderList
